import { useScrollReveal } from '@/hooks/useScrollReveal';
import { useStaggerReveal } from '@/hooks/useStaggerReveal';
import AnimatedCounter from '@/components/base/AnimatedCounter';

export default function AboutSection() {
  const { ref: headlineRef, isVisible: headlineVisible } = useScrollReveal({ threshold: 0.2 });
  const { ref: statsRef, isVisible: statsVisible } = useStaggerReveal({ threshold: 0.15 });

  return (
    <section id="about" className="relative py-24 md:py-36 bg-background-950 overflow-hidden">
      {/* Subtle top gradient transition from hero */}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-black/40 to-transparent pointer-events-none" />

      {/* Floating decorative illustration */}
      <div className="absolute bottom-[0%] right-[-30%] md:right-[-20%] lg:right-[-8%] xl:right-[2%] w-[28rem] md:w-[40rem] lg:w-[44rem] h-[28rem] md:h-[40rem] lg:h-[44rem] opacity-15 pointer-events-none animate-tilt-rotate z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%203D%20geometric%20neural%20network%20nodes%2C%20interconnected%20floating%20spheres%20and%20glowing%20connection%20lines%2C%20aurora%20green%20and%20amber%20light%20accents%20on%20pure%20black%20background%2C%20minimalist%20tech%20aesthetic%2C%20soft%20ethereal%20glow%2C%20no%20text&width=800&height=800&seq=about-floating-illustration&orientation=squarish"
          alt=""
          className="w-full h-full object-contain"
          width={800}
          height={800}
        />
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6">
        {/* Overline */}
        <div
          ref={headlineRef}
          className={`mb-8 transition-all duration-1000 ${headlineVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
        </div>

        {/* Dramatic headline with accent */}
        <div
          className={`transition-all duration-1000 delay-200 ${headlineVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] tracking-tight max-w-5xl">
            <span className="text-primary-400">One unified team</span><br />
            from first code to market success
          </h2>
        </div>

        {/* Description row */}
        <div className="mt-12 md:mt-16 flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div
            className={`lg:w-1/2 transition-all duration-1000 delay-300 ${headlineVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <p className="text-white/50 text-base md:text-lg leading-relaxed">
              AInnovation is a software development company for businesses tired of assembling technologies from separate vendors. We build custom software, develop AI and create the marketing tools that put it to work — all with one team, one point of contact.
            </p>
          </div>

        </div>

        {/* Divider */}
        <div className="mt-16 md:mt-20 h-px bg-white/10" />
      </div>
    </section>
  );
}